<template>
  <div>
    <p>The data with ID {{this.$route.query.sid}} is submitted successfully. Please wait patiently for the operation result.</p>
    <p>The URL of the result page is <span style="font-size: 20px;color: #5daf34"><el-link type="success" style="font-size: 20px;" :href=link>https://www.csuligroup.com/AIDrugDesigner/#/{{this.Category}}/{{this.$route.query.sid}}</el-link></span> .</p>
    <p>We will contact you by email after the program running results are available.</p>
    <el-result icon="success" title="Summitted successfully!" subTitle="">
      <template slot="extra">
        <el-button type="primary" size="medium" @click="$router.push('/home')">Back</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  name: "Success",
  data()
  {
    return{
      Category:'',
      // link:'http://120.24.94.89:8090/#/'
      link:'https://www.csuligroup.com/AIDrugDesigner/#/'
    }
  },
  methods:{
  },
  created() {
    // console.log(this.$route)
    axios.get("/getCategory",{params:{uuid:this.$route.query.sid}}).then(res => {

      // console.log(res.data)
      this.Category=res.data
      this.link += this.Category+'/'+this.$route.query.sid
      // console.log(this.link)
    })
  }
}
</script>

<style scoped>

</style>
